import React from 'react'
import { Card, Row, Col, Avatar, Tooltip, Spin, message } from 'antd'
import { get, groupBy, isEmpty } from 'lodash'
import TaskCalendarv2 from "./TaskCalendarv2";
import moment from 'moment';
import Request from "../../Lib/RequestV2";

class ViewAsCalendar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      //calendar
      month: [],
      year: [],
      spinning: false,
      vector: 'month',
      search: {}
    }

  }

  componentDidMount() {
    this.retreive()
  }


  onChangeview = (e, s) => {
    this.retreive(e, s)
  }

  selectMonth = (e) => {
    this.setState({ vector: 'month' }, () => this.retreive(e, 'month'))
  }

  retreive = (date = new Date(), calendar_type = 'month') => {
    this.setState({ spinning: true, vector: calendar_type }, () => {
      const token = localStorage.getItem('token')
      const start = moment(date).startOf(calendar_type).format("YYYY-MM-DD")
      const end = moment(date).endOf(calendar_type).format("YYYY-MM-DD")
      const [p, s] = [this.props, this.state]
      Request(
        "GET",
        token,
        "task-calendar-list",
        {},
        { start, end, calendar_type },
        [],
        (res, e) => {
          this.setState({ [calendar_type]: res.data, spinning: false })
        },
        (res) => {
          this.setState({ spinning: false })
          message.error('Something went wrong')
          console.warn(res)
        }
      );
    })
  }

  onSearch = (search, res) => {
    const [s] = [this.state]
    let obj = { search: {} }
    if (search)
      obj.search = { search }
    this.setState(obj, () => this.retreive(res, s.vector))
  }

  changeS = (e) => {
    const w = { search: {} }
    if (e.target.value)
      w.search = { search: e.target.value }
    this.setState(w)
  }

  render() {
    const [s, p] = [this.state, this.props]
    return (
      <Spin spinning={s.spinning}>
        <TaskCalendarv2
          task={s.month}
          loading={s.spinning}
          yjobs={s.year}
          setQuery={(obj) => this.setState(obj)}
          changeS={this.changeS}
          onSearch={this.onSearch}
          userReducer={p.userReducer}
          selectMonth={this.selectMonth}
          onChangeview={this.onChangeview}
          vector={s.vector}
        />
      </Spin>
    )
  }
}

export default ViewAsCalendar



// WEBPACK FOOTER //
// ./src/containers/Tasks/ViewAsCalendar.js